import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@sisumail/ui/style.css';
import './lib/env'; // Startup Validation
import App from './App';
import { initGlobalErrorHandlers } from './lib/logger';

// Initialize Logger
// Initialize Logger
initGlobalErrorHandlers();

// 💎 DIAMOND: Enforce API Contract
// 💎 DIAMOND: Enforce API Contract
import { api } from './lib/api';

// api.checkVersion() is handled automatically by the client on request headers.


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 1000 * 60, // 1 minute
            retry: 1,
        },
    },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <App />
        </QueryClientProvider>
    </React.StrictMode>
);
